import { render, staticRenderFns } from "./PicOuterList.vue?vue&type=template&id=45da2d87&scoped=true&"
import script from "./PicOuterList.vue?vue&type=script&lang=js&"
export * from "./PicOuterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da2d87",
  null
  
)

export default component.exports